import React, { ReactElement } from 'react'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { SupportPage } from '@/components/support/SupportPage/SupportPage'

// TODO: Should gather the necessary data to populate this page via some kind of config
export const getStaticProps = (async (_context) => {
    return { props: { courseConfigType: CourseConfigType.fsaHealth } }
}) satisfies GetStaticProps<BasePageProps>

const Page = (_props: BasePageProps): ReactElement => {
    return <SupportPage isLoggedIn={false} userInfoState={null} />
}

Page.isStatic = true

export default Page
